import React from 'react';
import './index.css';
import App from './App';
import {createRoot} from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import {SnackbarProvider} from 'notistack';
import {
    RecoilRoot
} from 'recoil';
import {QueryClientProvider, QueryClient} from "@tanstack/react-query";

const queryClient = new QueryClient()
const container = document.getElementById('root');
const root = createRoot(container);
root.render(
    <SnackbarProvider maxSnack={3}>
        <QueryClientProvider client={queryClient}>
            <RecoilRoot>
                <App/>
            </RecoilRoot>
        </QueryClientProvider>
    </SnackbarProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
